import { Info } from "lucide-react";

export function MockBanner() {
  return (
    <div className="bg-amber-100 border-b border-amber-200 text-amber-900 text-sm">
      <div className="mx-auto max-w-6xl px-4 py-2 flex items-center gap-2">
        <Info className="h-4 w-4 flex-shrink-0" />
        <span>
          <strong>Dev mode:</strong> Supabase env vars are not set. Returning mock extractions. See <code className="bg-amber-200/60 px-1 rounded">.env.example</code> to wire up real AI.
        </span>
      </div>
    </div>
  );
}
